import axios from 'axios'
import { Loading } from 'element-ui';

import config from '../../package.json'
export async function isNewVersion() {
    // let url = `//${window.location.host}/version.json?t=${new Date().getTime()}`
    // axios.get(url).then(res => {
    //   if (res.status === 200) {
        let vueVersion = config.version || '1.0.0'
        let localVueVersion = localStorage.getItem('vueVersion')
        localStorage.setItem('vueVersion', vueVersion)
        console.log(localVueVersion,vueVersion)
        if (localVueVersion && localVueVersion != vueVersion) {
          // alert('检测到新版本发布，请点击确认刷新页面哦')
          setInterval(() => {
            window.location.reload(true)
            return
          },1000*10)
        }
    //   }
    // })
}
// import axios from 'axios'; 
// import { Loading } from 'element-ui';
// var t1;
// var t2;
// export async function isNewVersion() {
//     var randomNumber=Math.random() 
//     const url = `//${window.location.host}/version.json?id=${randomNumber}`;
//     const res = await axios.get(url); 
//     const version = res.data.version;
//     const localVersion = localStorage.getItem('localVueVersion');
//     if (localVersion && localVersion != version) {
//         localStorage.setItem('localVueVersion', version);
//         const hide=()=>{
//             //我这里使用的是
//             // let loadingInstance =Loading.service({ fullscreen: true,text:'版本正在更新渲染加载中...'});
//             clearTimeout(t1)
//         }
//         t1=setTimeout(hide,2000)
//         t2=setTimeout(()=>{
//             clearTimeout(t2)
//             window.location.reload();
//         },3000)
//     } else {
//         localStorage.setItem('localVueVersion', version);
//     }
// }


// WEBPACK FOOTER //
// ./src/utils/versionUpdate.js